import { z } from 'zod';
import { CompanyType } from '../enums';

export { CompanyType };

export const CompanyTypeSchema = z.nativeEnum(CompanyType);

export const CompanySchema = z.object({
  id: z.string().uuid(),
  name: z.string().min(1),
  types: z.array(CompanyTypeSchema).default([]),
  phone: z.string().nullable(),
  email: z.string().nullable(),
  website: z.string().nullable(),
  address: z.string().nullable(),
  notes: z.string().nullable(),
  created_by: z.string().uuid().nullable(),
  created_at: z.string().datetime(),
  updated_at: z.string().datetime(),
});

export const CreateCompanySchema = z.object({
  name: z.string().min(1, 'Company name is required'),
  types: z.array(CompanyTypeSchema).optional().default([]),
  phone: z.string().optional(),
  email: z.string().optional(),
  website: z.string().optional(),
  address: z.string().optional(),
  notes: z.string().optional(),
});

export const UpdateCompanySchema = z.object({
  name: z.string().min(1).optional(),
  types: z.array(CompanyTypeSchema).optional(),
  phone: z.string().nullable().optional(),
  email: z.string().nullable().optional(),
  website: z.string().nullable().optional(),
  address: z.string().nullable().optional(),
  notes: z.string().nullable().optional(),
});

export const CompanyQuerySchema = z.object({
  page: z.coerce.number().int().positive().default(1),
  limit: z.coerce.number().int().positive().max(100).default(50),
  search: z.string().optional(),
  type: CompanyTypeSchema.optional(),
});

// ─── Contacts ────────────────────────────────────────────────────

export const ContactSchema = z.object({
  id: z.string().uuid(),
  company_id: z.string().uuid(),
  name: z.string().min(1),
  phone: z.string().nullable(),
  email: z.string().nullable(),
  title: z.string().nullable(),
  created_at: z.string().datetime(),
  updated_at: z.string().datetime(),
});

export const CreateContactSchema = z.object({
  name: z.string().min(1, 'Contact name is required'),
  phone: z.string().optional(),
  email: z.string().optional(),
  title: z.string().optional(),
});

export const UpdateContactSchema = z.object({
  name: z.string().min(1).optional(),
  phone: z.string().nullable().optional(),
  email: z.string().nullable().optional(),
  title: z.string().nullable().optional(),
});

// ─── Types ───────────────────────────────────────────────────────

export type Company = z.infer<typeof CompanySchema>;
export type CreateCompany = z.infer<typeof CreateCompanySchema>;
export type UpdateCompany = z.infer<typeof UpdateCompanySchema>;
export type CompanyQuery = z.infer<typeof CompanyQuerySchema>;
export type CompanyTypeEnum = z.infer<typeof CompanyTypeSchema>;
export type Contact = z.infer<typeof ContactSchema>;
export type CreateContact = z.infer<typeof CreateContactSchema>;
export type UpdateContact = z.infer<typeof UpdateContactSchema>;
